import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  const [route, setRoute] = useState(window.location.hash || '');
  useEffect(() => {
    const handleHashChange = () => {
      setRoute(window.location.hash);
      window.scrollTo(0, 0);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  // Simple router
  if (route === '#checkout') {
    return <CheckoutPage data-id="element-0" />;
  }
  if (route === '#thank-you') {
    return <ThankYouPage data-id="element-1" />;
  }
  if (route === '#terms') {
    return <TermsPage data-id="element-2" />;
  }
  if (route === '#privacy') {
    return <PrivacyPage data-id="element-3" />;
  }
  if (route === '#contact') {
    return <ContactPage data-id="element-4" />;
  }
  // Default to Landing Page
  return <LandingPage data-id="element-5" />;
}